import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import ItemGrid from "./ItemGrid";
import ItemGridMore from "./ItemGridMore";
import ItemGridScroll from "./ItemGridScroll";

const ContainerGrid = createReactClass({
  propTypes: {
    materialsToRender: PropTypes.array.isRequired,
    displayMore: PropTypes.bool,
    scrollActive: PropTypes.bool.isRequired,
  },

  render: function () {
    const grids = this.props.materialsToRender.map(material => {
      return <ItemGrid key={material.sMatHdrMatnr} material={material} />;
    });

    return (
      <React.Fragment key="ContainerGrid">
        {grids}
        <ItemGridMore
          displayMore={this.props.displayMore || false}
          numberOfResults={this.props.materialsToRender.length}
        />
        <ItemGridScroll scrollActive={this.props.scrollActive} />
      </React.Fragment>
    );
  },
});

export default ContainerGrid;
